import React from 'react';
import { RouteProp, useNavigation, useRoute, CommonActions } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TAppointmentType } from '../constants/appointmentModality';
import { WherebyRoom } from '../components/whereby/WherebyRoom';

const WherebyRoomScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{
        roomUrl: string;
        displayName?: string;
        appointmentType?: TAppointmentType;
        professional?: {
            fullName?: string;
            title?: string;
        };
    }>, 'WherebyRoomScreen'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const roomUrl = route.params?.roomUrl;
    const displayName = route.params?.displayName;
    const professional = route.params?.professional;
    const appointmentType = route.params?.appointmentType ?? 'televisit';

    const handleClose = () => {
        navigation.dispatch(
            CommonActions.reset({
                index: 0,
                routes: [{ name: 'Main' }],
            })
        );
    };

    if (!roomUrl) {
        handleClose();
        return null;
    }

    return <WherebyRoom roomUrl={roomUrl} displayName={displayName} onClose={handleClose} professional={professional} appointmentType={appointmentType} />;
};

export default WherebyRoomScreen;
